import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { Types } from "./Types";

import { Get_Clients, delete_Clients } from "Services/Requests";

import Styles from "Styles/Styles.module.css";

function ClientsComp() {
    const Navigate = useNavigate();
    let TableHead = ["Client", "Email", "Mobile Number", "Actions"];
    const [Clients, setClients] = useState<Types[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const getClients = async () => {
        try {
            const response = await Get_Clients();
            if (response?.data?.Status === 1) {
                setClients(response?.data?.data);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const DeleteClient = async (id: any) => {
        setLoading(true);
        try {
            const response = await delete_Clients(id);
            if (response?.data?.Status === 1) {
                Toast("Client Deleted Successfully", "success");
                getClients();
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        getClients();
    }, []);

    const deleteHandler = (item: Types) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete Client?",
            () => DeleteClient(item.clientId),
            "Delete"
        );
    };
    return (
        <div className={Styles["Container"]}>
            <header>
                <h3>Clients</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/clients/add")}>
                    <FiPlus />
                    Add Client
                </button>
            </header>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {Clients.length > 0 ? (
                                Clients?.map((item) => (
                                    <tr key={item?.clientId}>
                                        {/*    <td
                                          >
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.banner_image}
                                                    alt="banner"
                                                />
                                                <div>
                                                    <p>{item.banner_name}</p>
                                                </div>
                                            </div>
                                        </td> */}
                                        <td>{item?.clientName}</td>
                                        <td>{item?.emailId}</td>

                                        <td>{item.mobileNumber}</td>

                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/clients/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No clients Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default ClientsComp;
